import { useLocation } from 'react-router-dom';

// Turkish pages live at the root (/services); English and German ones under /en and /de.
export const LANGUAGES = [
    { code: 'tr', label: 'TR', name: 'Türkçe' },
    { code: 'en', label: 'EN', name: 'English' },
    { code: 'de', label: 'DE', name: 'Deutsch' },
];

const PREFIXED = ['en', 'de'];

// Number formatting per language (decimal comma in Turkish and German)
export const LOCALES = { tr: 'tr-TR', en: 'en-GB', de: 'de-DE' };

export function langFromPath(pathname) {
    return PREFIXED.find((code) => pathname === `/${code}` || pathname.startsWith(`/${code}/`)) || 'tr';
}

// '/services#tasarim' -> '/en/services#tasarim' for English, '/de/services#tasarim' for German
export function localizePath(path, lang) {
    if (!PREFIXED.includes(lang)) return path;
    return path === '/' || path.startsWith('/#') ? `/${lang}${path.slice(1)}` : `/${lang}${path}`;
}

// The same page in another language
export function switchLanguagePath(pathname, lang) {
    const current = langFromPath(pathname);
    const base = current === 'tr' ? pathname : pathname.slice(current.length + 1) || '/';
    return localizePath(base, lang);
}

// Read by netlify/edge-functions/language-redirect.js, so a visitor's explicit
// choice beats the country-based default on later visits to the home page.
export function rememberLanguage(lang) {
    document.cookie = `akka_lang=${lang}; path=/; max-age=31536000; SameSite=Lax`;
}

export function useLang() {
    const { pathname } = useLocation();
    return langFromPath(pathname);
}

// Text shared by the navbar, footer and layout
export const UI = {
    tr: {
        nav: { home: 'Ana Sayfa', company: 'Şirket', research: 'Bilgi', services: 'Hizmetler', contact: 'İletişim' },
        mainMenu: 'Ana menü',
        openMenu: 'Menüyü aç',
        closeMenu: 'Menüyü kapat',
        language: 'Dil seçimi',
        quote: 'Teklif Al',
        footer: {
            tagline: 'Size en iyi hizmeti ve ürünü vermek için buradayız.',
            corporate: 'Kurumsal',
            about: 'Hakkımızda',
            research: 'Bilgi Merkezi',
            videos: 'Video Kütüphanesi',
            guide: 'Tasarım Rehberi',
            calculators: 'Hesaplama Araçları',
            contact: 'İletişim',
            services: 'Hizmetler',
            serviceLinks: ['Lazer Kesim', 'Abkant Büküm', 'Kaynaklı İmalat', 'Tasarım'],
            otherServices: ['Montaj', 'Hammadde Tedarik'],
            admin: 'Yönetici Girişi',
            country: '',
        },
    },
    en: {
        nav: { home: 'Home', company: 'Company', research: 'Resources', services: 'Services', contact: 'Contact' },
        mainMenu: 'Main menu',
        openMenu: 'Open menu',
        closeMenu: 'Close menu',
        language: 'Language',
        quote: 'Get a Quote',
        footer: {
            tagline: 'We are here to give you the best service and products.',
            corporate: 'Company',
            about: 'About Us',
            research: 'Resource Center',
            videos: 'Video Library',
            guide: 'Design Guide',
            calculators: 'Calculators',
            contact: 'Contact',
            services: 'Services',
            serviceLinks: ['Laser Cutting', 'Press Brake Bending', 'Welded Fabrication', 'Design'],
            otherServices: ['Assembly', 'Raw Material Supply'],
            admin: 'Admin Login',
            country: ', Türkiye',
        },
    },
    de: {
        nav: { home: 'Startseite', company: 'Über uns', research: 'Wissen', services: 'Leistungen', contact: 'Kontakt' },
        mainMenu: 'Hauptmenü',
        openMenu: 'Menü öffnen',
        closeMenu: 'Menü schließen',
        language: 'Sprache',
        quote: 'Jetzt anfragen',
        footer: {
            tagline: 'Wir sind für Sie da – mit bestem Service und hochwertigen Produkten.',
            corporate: 'Unternehmen',
            about: 'Über uns',
            research: 'Wissenszentrum',
            videos: 'Videothek',
            guide: 'Konstruktionsleitfaden',
            calculators: 'Rechner',
            contact: 'Kontakt',
            services: 'Leistungen',
            serviceLinks: ['Laserschneiden', 'Abkanten', 'Schweißbaugruppen', 'Konstruktion'],
            otherServices: ['Montage', 'Materialbeschaffung'],
            admin: 'Admin-Anmeldung',
            country: ', Türkei',
        },
    },
};
